// Mock data for ONEAVIATION LLP website

export const companyInfo = {
  name: "ONEAVIATION LLP",
  tagline: "Beyond Skies",
  description: "One-roof solutions in the aviation sector, specializing in Leasing, Spares & Parts, Service & MRO",
  email: "info@oneaviation.org",
  phone: "+91-9975515565",
  address: "7 Hills, Vaishanvi City phase 2, Uruli Devachi, Pune 412308",
  logo: "/oneaviation-logo.webp"
};

export const services = [
  {
    id: 1,
    title: "Aircraft Leasing",
    icon: "Plane",
    description: "Flexible aircraft leasing solutions tailored to your operational needs. From short-term to long-term leases, we provide comprehensive support.",
    features: [
      "Operating Lease",
      "Finance Lease",
      "Sale and Leaseback",
      "Flexible Terms"
    ],
    image: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc3MTA0NTY2Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Spares & Parts Sales",
    icon: "ShoppingCart",
    description: "Comprehensive inventory of genuine aviation spares and parts with global sourcing capabilities. Quality-assured components for all your aircraft needs.",
    features: [
      "OEM & Aftermarket Parts",
      "Global Parts Sourcing",
      "Quality Certification",
      "Rapid Delivery Support"
    ],
    image: "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc3MTA0NTY2Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Aviation Services",
    icon: "Settings",
    description: "Comprehensive aviation support services ensuring operational excellence and regulatory compliance.",
    features: [
      "Technical Support",
      "Aircraft Management",
      "Consulting Services",
      "Regulatory Compliance"
    ],
    image: "https://images.unsplash.com/photo-1585916788784-64aa099fec1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhaXJjcmFmdCUyMGhhbmdhcnxlbnwwfHx8fDE3NzEwNDU2Njd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "MRO Services",
    icon: "Wrench",
    description: "State-of-the-art Maintenance, Repair, and Overhaul services ensuring aircraft airworthiness and safety.",
    features: [
      "Scheduled Maintenance",
      "Component Repair",
      "Aircraft Modifications",
      "AOG Support 24/7"
    ],
    image: "https://images.unsplash.com/photo-1708651425547-d5410c1caa44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxhaXJjcmFmdCUyMGhhbmdhcnxlbnwwfHx8fDE3NzEwNDU2Njd8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const projects = [
  {
    id: 1,
    title: "Boeing 737 Fleet Leasing",
    category: "Leasing",
    description: "Successfully leased a fleet of 5 Boeing 737-800s to a major regional carrier.",
    image: "https://images.unsplash.com/photo-1767960816704-69682c77c6e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhdmlhdGlvbiUyMGFpcmNyYWZ0fGVufDB8fHx8MTc3MTA0NTY1OHww&ixlib=rb-4.1.0&q=85",
    year: "2024"
  },
  {
    id: 2,
    title: "Engine Components Supply",
    category: "Sales",
    description: "Supplied critical engine components and spares for fleet of commercial aircraft across Asia Pacific.",
    image: "https://images.unsplash.com/photo-1760183957226-8ad1e94c863f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhdmlhdGlvbiUyMGFpcmNyYWZ0fGVufDB8fHx8MTc3MTA0NTY1OHww&ixlib=rb-4.1.0&q=85",
    year: "2024"
  },
  {
    id: 3,
    title: "Heavy Maintenance Check",
    category: "MRO",
    description: "Completed C-check on Boeing 777 with zero defects and ahead of schedule.",
    image: "https://images.unsplash.com/photo-1649886535045-246644def7d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxhaXJjcmFmdCUyMGhhbmdhcnxlbnwwfHx8fDE3NzEwNDU2Njd8MA&ixlib=rb-4.1.0&q=85",
    year: "2023"
  },
  {
    id: 4,
    title: "Private Jet Management",
    category: "Services",
    description: "Full management services for a Gulfstream G650 fleet including crew and scheduling.",
    image: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc3MTA0NTY2Mnww&ixlib=rb-4.1.0&q=85",
    year: "2023"
  },
  {
    id: 5,
    title: "ATR Fleet Upgrade",
    category: "MRO",
    description: "Avionics upgrade program for ATR 72-600 fleet modernization.",
    image: "https://images.unsplash.com/photo-1764547168984-f1eae13ef38e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhdmlhdGlvbiUyMGFpcmNyYWZ0fGVufDB8fHx8MTc3MTA0NTY1OHww&ixlib=rb-4.1.0&q=85",
    year: "2023"
  },
  {
    id: 6,
    title: "Avionics Parts Distribution",
    category: "Sales",
    description: "Comprehensive avionics parts supply for regional fleet modernization program.",
    image: "https://images.unsplash.com/photo-1770442380908-84707d594e8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhdmlhdGlvbiUyMGFpcmNyYWZ0fGVufDB8fHx8MTc3MTA0NTY1OHww&ixlib=rb-4.1.0&q=85",
    year: "2024"
  }
];

export const team = [
  {
    id: 1,
    name: "Rajesh Sharma",
    position: "Chief Executive Officer",
    bio: "25+ years in aviation industry with expertise in aircraft leasing and fleet management.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Priya Patel",
    position: "Director of Sales",
    bio: "Expert in aircraft transactions with a track record of successful deals across Asia Pacific.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Vikram Singh",
    position: "Head of MRO Operations",
    bio: "Licensed aircraft engineer with 20 years of maintenance and technical expertise.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Anjali Desai",
    position: "Chief Financial Officer",
    bio: "Specialist in aviation finance and structured leasing solutions.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Johnson",
    position: "CEO, SkyHigh Airlines",
    content: "ONEAVIATION LLP provided exceptional leasing solutions that helped us expand our fleet efficiently. Their professionalism and industry knowledge are unmatched.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Sarah Williams",
    position: "Fleet Manager, AeroConnect",
    content: "The MRO services from ONEAVIATION exceeded our expectations. Quick turnaround times and impeccable quality on every maintenance check.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "David Chen",
    position: "Director, Pacific Aviation Group",
    content: "Outstanding spares & parts supply support. They consistently deliver quality components on time, helping us maintain our fleet efficiently.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  }
];

export const stats = [
  {
    value: "50+",
    label: "Aircraft Managed"
  },
  {
    value: "15+",
    label: "Years Experience"
  },
  {
    value: "100+",
    label: "Successful Projects"
  },
  {
    value: "24/7",
    label: "Support Available"
  }
];

export const clients = [
  "Air India",
  "IndiGo",
  "SpiceJet",
  "Vistara",
  "GoAir",
  "AirAsia India"
];
